'use client';
import React, { ReactElement } from 'react';
import { PickersDay } from '@mui/x-date-pickers';
import { alpha } from '@mui/material/styles';
import { RangeDayProps } from './range-day-props.interface';

const RangeDay = (props: RangeDayProps): ReactElement => {
  const { isWithinRange, isRangeStart, isRangeEnd, ...pickersDayProps } = props;

  const isBoundary = isRangeStart || isRangeEnd;
  const isSingleDay = isRangeStart && isRangeEnd;

  let boundaryBorderRadius = '50%';

  if (isRangeStart && !isSingleDay) {
    boundaryBorderRadius = '50% 0 0 50%';
  }

  if (isRangeEnd && !isSingleDay) {
    boundaryBorderRadius = '0 50% 50% 0';
  }

  const rangeDay: ReactElement = (
    <PickersDay
      {...pickersDayProps}
      selected={false}
      sx={{
        ...(isWithinRange && {
          backgroundColor: (theme) => alpha(theme.palette.tertiary.main, 0.12),
          borderRadius: 0,
        }),
        ...(isBoundary && {
          borderRadius: boundaryBorderRadius,
          backgroundColor: (theme) => theme.palette.tertiary.main,
          color: (theme) => theme.palette.tertiary.contrastText,
          '&:hover, &:focus, &:focus-visible': {
            backgroundColor: (theme) => theme.palette.tertiary.dark,
          },
        }),
      }}
    />
  );

  return rangeDay;
};

export default RangeDay;
